import { startLoading, endLoading } from './app-dux';
import sort from '../utils/sort';
import { EMPLOYMENT_ATTRIBUTES, LABELS, HIERARCHY_NODE_ROLE_TYPES, STATUS_TYPES } from '../constants';
import rosterService from '../services/roster';
import cashierService from '../services/cashier';
import profileService from '../services/profile';
import companyService from '../services/company';
import harryService from '../services/harry';
/*******************************************************************************
 * Initial geographicalRegion
 */
const initialState = {
    persons: [],
    personsPages: 0,
    didSearchPersons: false,
    personDetail: {
        id: '',
        externalId: '',
        username: '',
        locale: '',
        status: '',
        givenName: '',
        surname: '',
        country: '',
        personEmails: [],
        personAddresses: [],
        nodes: [],
        personAttributes: [],
        awardbanqNumber: '',
        centraxId: '',
        currentBalance: '',
        accountRecovery: {}
    },
    countryList: [],
    geographicalRegionList: [],
    hierarchyList: [],
    hierarchyNodeList: [],
    hierarchyNodeRoleList: [],
    hierarchyNodeTypeList: [],
    localeList: [],
    departmentList: [],
    employerList: [],
    jobTitleList: [],
    locationList: [],
    emailLabelList: [],
    statusList: []
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_PERSONS = 'SET_PERSONS';
export const SET_PERSON_DETAIL = 'SET_PERSON_DETAIL';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';
export const SET_GEOGRAPHICAL_REGION_LIST = 'SET_GEOGRAPHICAL_REGION_LIST';
export const SET_HIERARCHY_LIST = 'SET_HIERARCHY_LIST';
export const SET_HIERARCHY_NODE_LIST = 'SET_HIERARCHY_NODE_LIST';
export const SET_HIERARCHY_NODE_ROLE_LIST = 'SET_HIERARCHY_NODE_ROLE_LIST';
export const SET_HIERARCHY_NODE_TYPE_LIST = 'SET_HIERARCHY_NODE_TYPE_LIST';
export const SET_LOCALE_LIST = 'SET_LOCALE_LIST';
export const SET_DEPARTMENT_LIST = 'SET_DEPARTMENT_LIST';
export const SET_EMPLOYER_LIST = 'SET_EMPLOYER_LIST';
export const SET_JOB_TITLE_LIST = 'SET_JOB_TITLE_LIST';
export const SET_LOCATION_LIST = 'SET_LOCATION_LIST';
export const SET_EMAILL_LABEL_LIST = 'SET_EMAILL_LABEL_LIST';
export const SET_STATUS_LIST = 'SET_STATUS_LIST';
export const CLEAR_PERSON_DETAIL = 'CLEAR_PERSON_DETAIL';
export const SET_ALL_LISTS = 'SET_LISTS';

/*******************************************************************************
 * Reducer
 */
export default function searchReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_PERSONS: {
            return {
                ...state,
                persons: action.persons,
                personsPages: Math.ceil( action.recordCount / action.pageSize ),
                didSearchPersons: action.didSearch
            };
        }
        case SET_PERSON_DETAIL: {
            return {
                ...state,
                personDetail: {
                    ...action.personDetail,
                    personEmails: [ ...action.personDetail.personEmails ],
                    personAddresses: [ ...action.personDetail.personAddresses ],
                    personAttributes: [ ...action.personDetail.personAttributes ],
                    nodes: [ ...action.personDetail.nodes ],
                    accountRecovery: { ...action.personDetail.accountRecovery }
                }
            };
        }
        case SET_ERRORS: {
            return {
                ...state,
                errors: action.errors
            };
        }
        case SET_COUNTRY_LIST: {
            return {
                ...state,
                countryList: sort( action.countryList, 'name' ),
                geographicalRegionList: []
            };
        }
        case SET_GEOGRAPHICAL_REGION_LIST: {
            return {
                ...state,
                geographicalRegionList: sort( action.geographicalRegionList, 'name' )
            };
        }
        case SET_HIERARCHY_NODE_LIST: {
            return {
                ...state,
                hierarchyNodeList: sort( action.hierarchyNodeList, 'name' )
            };
        }
        case SET_HIERARCHY_NODE_ROLE_LIST: {
            return {
                ...state,
                hierarchyNodeRoleList: action.hierarchyNodeRoleList.sort()
            };
        }
        case SET_HIERARCHY_NODE_TYPE_LIST: {
            return {
                ...state,
                hierarchyNodeTypeList: [ ... new Set( action.hierarchyNodeTypeList ) ].sort()
            };
        }
        case SET_LOCALE_LIST: {
            return {
                ...state,
                localeList: action.localeList
            };
        }
        case SET_DEPARTMENT_LIST: {
            return {
                ...state,
                departmentList: action.departmentList.sort()
            };
        }
        case SET_EMPLOYER_LIST: {
            return {
                ...state,
                employerList: action.employerList.sort()
            };
        }
        case SET_JOB_TITLE_LIST: {
            return {
                ...state,
                jobTitleList: action.jobTitleList.sort()
            };
        }
        case SET_LOCATION_LIST: {
            return {
                ...state,
                locationList: action.locationList.sort()
            };
        }
        case SET_EMAILL_LABEL_LIST: {
            return {
                ...state,
                emailLabelList: action.emailLabelList
            };
        }
        case SET_STATUS_LIST: {
            return {
                ...state,
                statusList: action.statusList
            };
        }
        case SET_HIERARCHY_LIST: {
            return {
                ...state,
                hierarchyList: sort( action.hierarchyList, 'name' )
            };
        }
        case SET_ALL_LISTS: {
            return {
                ...state,
                countryList: sort( action.lists.countryList, 'name' ),
                geographicalRegionList: [],
                hierarchyList: sort( action.lists.hierarchyList, 'name' ),
                hierarchyNodeList: sort( action.lists.hierarchyNodeList, 'name' ),
                hierarchyNodeRoleList: action.lists.hierarchyNodeRoleList.sort(),
                hierarchyNodeTypeList: [ ... new Set( action.lists.hierarchyNodeTypeList ) ].sort(),
                localeList: action.lists.localeList,
                departmentList: action.lists.departmentList.sort(),
                employerList: action.lists.employerList.sort(),
                jobTitleList: action.lists.jobTitleList.sort(),
                locationList: action.lists.locationList.sort(),
                emailLabelList: action.lists.emailLabelList,
                statusList: action.lists.statusList
            };
        }
        case CLEAR_PERSON_DETAIL: {
            return {
                ...state,
                personDetail: initialState.personDetail
            };
        }
        default:
            return state;
    }
}

export function searchPersons( accessToken, companyId, searchInput = '', pageNumber = 1, searchModifier = {}, hierarchyId ) {
    const RosterService = new rosterService( accessToken, companyId );
    return async ( dispatch ) => {
        try {
            dispatch( startLoading() );

            if ( searchInput.length > 2 ) {
                const results = await RosterService.searchPersons( {
                    searchInput,
                    pageNumber,
                    pageSize: 50,
                    searchModifier,
                    hierarchyId
                } );
                dispatch( setPersons( results ) );
            } else {
                dispatch( resetPersons() );
            }
        } finally {
            dispatch( endLoading() );
        }
    };
}
export function advancedSearchPersons( searchParams = {}, pageNumber = 1, searchModifier = {}, accessToken, companyId, ) {
    return async ( dispatch ) => {
        try {
            dispatch( startLoading() );
            const RosterService = new rosterService( accessToken, companyId );
            const results = await RosterService.advancedSearchPersons( {
                searchParams,
                pageNumber,
                pageSize: 50,
                searchModifier
            } );

            dispatch( setPersons( results ) );

        } catch ( error ) {
            throw new Error( error );
        } finally {
            dispatch( endLoading() );
        }
    };
}

export function advancedSearchRecoveryEmail( accessToken, companyId, emailAddress, pageNumber = 1, searchModifier = {} ) {
     const RosterService = new rosterService( accessToken, companyId );
    const ProfileService = new profileService( accessToken, companyId );
    let personIdArray = [];
    return async ( dispatch ) => {
        try {
            dispatch( startLoading() );
            const profileResults = await ProfileService.searchRecovery( emailAddress );
            personIdArray = profileResults.map( profile => (  profile.personId  ) );
            if ( personIdArray.length !== 0 ) {
                const results = await RosterService.advancedSearchPersons( {
                    searchParams: { personIds: personIdArray },
                    pageNumber,
                    pageSize: 50,
                    searchModifier
                } );
                dispatch( setPersons( results ) );
            } else {
                dispatch( setPersons( [] ) );
            }
        } catch ( error ) {
            throw new Error( error );
        } finally {
            dispatch( endLoading() );
        }
    };
}

export function getPerson( accessToken, personId, companyId ) {
    const RosterService = new rosterService( accessToken, companyId );
    const ProfileService = new profileService( accessToken, companyId );
    const CashierService = new cashierService( accessToken, companyId );
    return async ( dispatch ) => {
        try {
            dispatch( startLoading() );

            let rosterData = null;
            let bankAccount = null;
            let currentBalance = null;
            let accountRecovery = null;
            let awardbanqNumber = null;
            let centraxId = null;
            const [
                rosterResult,
                bankAccountResult,
                currentBalanceResult,
                accountRecoveryResult
            ] = await Promise.allSettled( [
                RosterService.getPersonDetailed( personId ),
                CashierService.getAccountInformation( personId ),
                CashierService.getPointBalance( personId ),
                ProfileService.getRecovery( personId )
            ] );
             
            if ( rosterResult.status === 'fulfilled' ) {
                rosterData = rosterResult.value;
            } else {
                console.error( 'Error fetching person details:', rosterResult.reason );
            }
             
            if ( bankAccountResult.status === 'fulfilled' ) {
                bankAccount = bankAccountResult.value;
            } else {
                console.error( 'Error fetching account information:', bankAccountResult.reason );
            }
             
            if ( currentBalanceResult.status === 'fulfilled' ) {
                currentBalance = currentBalanceResult.value;
            } else {
                console.error( 'Error fetching point balance:', currentBalanceResult.reason );
            }
             
            if ( accountRecoveryResult.status === 'fulfilled' ) {
                accountRecovery = accountRecoveryResult.value;
            } else {
                console.error( 'Error fetching recovery info:', accountRecoveryResult.reason );
            }

            if ( bankAccount ) {
                awardbanqNumber = bankAccount.awardbanqNumber;
                centraxId = bankAccount.centraxId;
            }          
            const data = {
                ...rosterData,
                awardbanqNumber,
                centraxId,
                currentBalance,
                accountRecovery: { ...accountRecovery }
            };

            dispatch( setPersonDetail( data ) );
        } finally {
            dispatch( endLoading() );
        }
    };
}

export function setPersonDetail( personDetail ) {
    return {
        type: SET_PERSON_DETAIL,
        personDetail
    };
}

export function setPersons( personsResult ) {
    return {
        type: SET_PERSONS,
        ...personsResult,
        didSearch: true
    };
}

export function resetPersons() {
    return {
        type: SET_PERSONS,
        persons: [],
        recordCount: 0,
        pageSize: 50,
        didSearch: false
    };
}

export function savePerson( person, accessToken, companyId, isUmbrella ) {
    const RosterService = new rosterService( accessToken, companyId );
    const ProfileService = new profileService( accessToken, companyId );
    const CashierService = new cashierService( accessToken, companyId );
    return async ( dispatch, getState ) => {
        try {
            dispatch( startLoading() );
            const state = getState();
            // first, save any changes made to the base person object
            await RosterService.savePerson( person );
            // then update any dependent objects (attributes, emails, nodes, addresses )
            const { attributesToUpdate, emailsToUpdate, addressesToUpdate, nodesToUpdate, recoveryToUpdate } = person;
            if ( addressesToUpdate && addressesToUpdate.length ) {
                const personAddressPromises = addressesToUpdate.map( address => {
                    if ( address.id ) {
                        return RosterService.updatePersonPostalAddress( person.id, { ...address, country: address.countryCode } );
                    }
                    return RosterService.createPersonPostalAddress( person.id, { ...address, country: address.countryCode } );
                } );
                await Promise.all( personAddressPromises );
            }
            if ( emailsToUpdate && emailsToUpdate.length ) {
                const personEmailPromises = emailsToUpdate.map( email => {
                    const { address, label } = email;
                    if ( email.id ) {
                        return RosterService.updatePersonEmailAddress( person.id, email.id, { address, label } );
                    }
                    return RosterService.createPersonEmailAddress( person.id, { address, label } );
                } );
                await Promise.all( personEmailPromises );
            }
            if ( attributesToUpdate && attributesToUpdate.length ) {
                const {
                    search: { personDetail: { personAttributes } },
                    person: { attributeTypes }
                } = isUmbrella ? state.roster : state;

                const personAttributePromises = attributesToUpdate.map( attribute => {
                    const requestedAttribute = personAttributes.find( pa => pa.name.toLowerCase() === attribute.name.toLowerCase() );
                    if ( requestedAttribute ) {
                        if ( !attribute.value ) {
                            return RosterService.deletePersonAttribute( person.id, requestedAttribute.name );
                        } else {
                            return RosterService.updatePersonAttribute( person.id, requestedAttribute.name, attribute.value );
                        }
                    } else if ( attribute.value && RosterService.personAttributeTypeExists( attributeTypes, attribute.name ) ) {
                        return RosterService.createPersonAttribute( person.id, attribute.name, attribute.value );
                    }
                } );
                await Promise.all( personAttributePromises );
            }
            if ( nodesToUpdate && nodesToUpdate.length ) {
                const { search: { personDetail: { nodes } } } = isUmbrella ? state.roster : state;

                const nodeUpdatePromises = nodesToUpdate.map( nodeToUpdate => {
                    const foundNode = nodes.find( node => node.id === nodeToUpdate.id );
                    if ( foundNode && foundNode.roleType === nodeToUpdate.roleType ) {
                        return;
                    }
                    return RosterService.addPersonToHierarchyNode( person.id, nodeToUpdate.id, nodeToUpdate.roleType );
                } );
                await Promise.all( nodeUpdatePromises );

                const nodeRemovePromises = nodes.map( node => {
                    if ( node.id && !nodesToUpdate.find( nodeToUpdate => nodeToUpdate.id === node.id ) ) {
                        return RosterService.removePersonFromHierarchyNode( person.id, node.id );
                    }
                } );
                await Promise.all( nodeRemovePromises );
            }
            if ( recoveryToUpdate ) {
                await ProfileService.updateRecovery( person.id, recoveryToUpdate );
            }

            // refresh the store with updated person details
            let bankAccount = null;
            let currentBalance = null;
            let awardbanqNumber = null;
            let centraxId = null;
            const [
                rosterData,
                bankAccountResult,
                currentBalanceResult,
                accountRecovery
            ] = await Promise.all( [
                RosterService.getPersonDetailed( person.id ),
                CashierService.getAccountInformation( person.id ),
                CashierService.getPointBalance( person.id ),
                ProfileService.getRecovery( person.id )
            ] );

            if ( bankAccountResult?.status === 'fulfilled' ) {
                bankAccount = bankAccountResult.value;
            }
            if ( currentBalanceResult?.status === 'fulfilled' ) {
                currentBalance = currentBalanceResult.value;
            } 
            if ( bankAccount ) {
                awardbanqNumber = bankAccount.awardbanqNumber;
                centraxId = bankAccount.centraxId;
            } 

            const updatedData = {
                ...rosterData,
                awardbanqNumber,
                centraxId,
                currentBalance,
                accountRecovery: { ...accountRecovery }
            };

            dispatch( setPersonDetail( updatedData ) );
        } finally {
            dispatch( endLoading() );
        }
    };
}

export function loadLists( accessToken, companyId ) {
    return async ( dispatch ) => {
        try {
            dispatch( startLoading() );
            const HarryService = new harryService( accessToken );
            const RosterService = new rosterService( accessToken, companyId );
            const CompanyService = new companyService( accessToken );
            // get base lists
            const [
                countryList,
                hierarchyList,
                hierarchyNodeAttributes,
                localeList,
                personAttributeTypes,
            ] = await Promise.all( [
                HarryService.getCountryList(),
                RosterService.listHierarchies(),
                RosterService.getHierarchyNodeAttributeTypeList(),
                CompanyService.getCompanyLocales( companyId ),
                RosterService.getPersonAttributeTypes()
            ] );

            // combine node lists for the company's hierarchies
            const hierarchyNodeList = [];
            await Promise.all(
                await hierarchyList.map( async hierarchy => {
                    const nodes = await RosterService.getHierarchyNodes( hierarchy.id );
                    hierarchyNodeList.push( ...nodes );
                } )
            );

            // combine node attribute 'hierarchyNodeType' value lists for the company's hierarchies
            const hierarchyNodeTypeList = [];
            const requestedNodeAttribute = RosterService.findAttributeTypeByName( hierarchyNodeAttributes, 'hierarchyNodeType' );
            if ( requestedNodeAttribute ) {
                await Promise.all(
                    await hierarchyList.map( async hierarchy => {
                        const values = await RosterService.getHierarchyNodeAttributeValueList( hierarchy.id, requestedNodeAttribute.id );
                        hierarchyNodeTypeList.push( ...values );
                    } )
                );
            }

            // get company-wide value lists for each of the employment attributes
            const employmentAttributes = [
                EMPLOYMENT_ATTRIBUTES.DEPARTMENT,
                EMPLOYMENT_ATTRIBUTES.EMPLOYER,
                EMPLOYMENT_ATTRIBUTES.JOB_TITLE,
                EMPLOYMENT_ATTRIBUTES.LOCATION
            ];
            const employmentAttributeTypes = personAttributeTypes.filter( attribute => employmentAttributes.indexOf( attribute.name ) >= 0 );
            const employmentAttributeValueLists = {};
            await Promise.all(
                await employmentAttributeTypes.map( async attribute => {
                    const values = await RosterService.getPersonAttributeValueList( attribute.id );
                    employmentAttributeValueLists[ attribute.name + 'List' ] = values;
                } )
            );

            const { departmentList = [], employerList = [], jobTitleList = [], locationList = [] } = employmentAttributeValueLists;
            const hierarchyNodeRoleList = HIERARCHY_NODE_ROLE_TYPES;
            const emailLabelList = LABELS.EMAIL;
            const statusList = STATUS_TYPES;

            const lists = {
                countryList,
                hierarchyList,
                hierarchyNodeList,
                hierarchyNodeRoleList,
                hierarchyNodeTypeList,
                localeList,
                departmentList,
                employerList,
                jobTitleList,
                locationList,
                emailLabelList,
                statusList
            };

            dispatch( setAllLists( lists ) );

            return lists;
        } finally {
            dispatch( endLoading() );
        }
    };
}

export function deletePostalAddress( accessToken, companyId, personId, postalAddressId ) {
     const RosterService = new rosterService( accessToken, companyId );
    return async ( dispatch ) => {
        dispatch( startLoading() );
        await RosterService.deletePersonPostalAddress( personId, postalAddressId );
        dispatch( endLoading() );
    };
}

export function loadGeographicalRegionList( accessToken, iso3Code ) {
    const HarryService = new harryService ( accessToken );
    return async ( dispatch ) => {
        try {
            dispatch( startLoading() );

            if ( !iso3Code ) {
                dispatch( setGeographicalRegionList( [] ) );
                return [];
            }

            const geographicalRegionList = await HarryService.getGeographicalRegionList( iso3Code );

            dispatch( setGeographicalRegionList( geographicalRegionList ) );

            return sort( geographicalRegionList, 'name' );
        } finally {
            dispatch( endLoading() );
        }
    };
}
export function setCountryList( countryList ) {
    return {
        type: SET_COUNTRY_LIST,
        countryList
    };
}
export function setGeographicalRegionList( geographicalRegionList ) {
    return {
        type: SET_GEOGRAPHICAL_REGION_LIST,
        geographicalRegionList: geographicalRegionList
    };
}
export function setHierarchyNodeList( hierarchyNodeList ) {
    return {
        type: SET_HIERARCHY_NODE_LIST,
        hierarchyNodeList: hierarchyNodeList
    };
}
export function setHierarchyNodeRoleList( hierarchyNodeRoleList ) {
    return {
        type: SET_HIERARCHY_NODE_ROLE_LIST,
        hierarchyNodeRoleList: hierarchyNodeRoleList
    };
}
export function setHierarchyNodeTypeList( hierarchyNodeTypeList ) {
    return {
        type: SET_HIERARCHY_NODE_TYPE_LIST,
        hierarchyNodeTypeList: hierarchyNodeTypeList
    };
}
export function setLocaleList( localeList ) {
    return {
        type: SET_LOCALE_LIST,
        localeList: localeList
    };
}
export function setDepartmentList( departmentList ) {
    return {
        type: SET_DEPARTMENT_LIST,
        departmentList: departmentList
    };
}
export function setEmployerList( employerList ) {
    return {
        type: SET_EMPLOYER_LIST,
        employerList: employerList
    };
}
export function setJobTitleList( jobTitleList ) {
    return {
        type: SET_JOB_TITLE_LIST,
        jobTitleList: jobTitleList
    };
}
export function setLocationList( locationList ) {
    return {
        type: SET_LOCATION_LIST,
        locationList: locationList
    };
}
export function setEmailLabelList( emailLabelList ) {
    return {
        type: SET_EMAILL_LABEL_LIST,
        emailLabelList: emailLabelList
    };
}

export function setStatusList( statusList ) {
    return {
        type: SET_STATUS_LIST,
        statusList: statusList
    };
}

export function setHierarchyList( hierarchyList ) {
    return {
        type: SET_HIERARCHY_LIST,
        hierarchyList: hierarchyList
    };
}

export function clearPersonDetail() {
    return {
        type: CLEAR_PERSON_DETAIL
    };
}

export function setAllLists( lists ) {
    return {
        type: SET_ALL_LISTS,
        lists: lists
    };
}
